import { render, staticRenderFns } from "./AssignmentDescription.vue?vue&type=template&id=60bff3d0"
import script from "./AssignmentDescription.vue?vue&type=script&lang=js"
export * from "./AssignmentDescription.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDescription.vue?vue&type=style&index=0&id=60bff3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports